import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'roadie-ui'

type ButtonVariant = 'primary' | 'secondary' | 'tertiary'

type GuitarStyleProps = React.ComponentProps<typeof Button.A.Primary>

interface ButtonLinkProps
  extends React.ComponentPropsWithoutRef<typeof Link>,
    Omit<GuitarStyleProps, 'baseElement' | keyof React.ComponentPropsWithoutRef<typeof Link>> {
  variant?: ButtonVariant
}

const ButtonLink: React.FC<ButtonLinkProps> = ({ variant = 'tertiary', ...props }) => {
  const buttonComponents = {
    primary: Button.A.Primary,
    secondary: Button.A.Secondary,
    tertiary: Button.A.Tertiary,
  }

  const ButtonComponent = buttonComponents[variant]

  return <ButtonComponent baseElement={Link} {...props} />
}

export default ButtonLink
